export const PAGINATION_NEXT_BUTTON_NAME = 'Next &raquo;';
export const PAGINATION_PREVIOUS_BUTTON_NAME= '&laquo; Previous';
export const ACTION_EDIT = 'edit'
export const ACTION_DELETE = 'delete'
export const QUERY_TAKE_COUNT = 20;